import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrl: './list-item.component.scss'
})
export class ListItemComponent {
  @Input() isSuccess: boolean = false; // Condition for success or muted state
  @Input() iconSuccess: string = 'pi pi-check'; // Icon for success
  @Input() iconDefault: string = 'pi pi-circle-on'; // Icon for default
}
